import { Button } from "@blacknut/react-sdk/dist";
import clsx from "clsx";
import { useHistory } from "react-router";
import electronService from "../../../services/ElectronService";
import { HeaderStyle } from "../../../theme/Theme";
import { ReactComponent as BackIcon } from "../../../assets/dist/ic_arrow_back_active.svg";
import styles from "./styles.module.scss";
import React from "react";
interface HeaderBackButtonProps {
  title?: string;
  headerStyle?: Partial<HeaderStyle>;
  onClick?: () => void;
  className?: string;
}
const HeaderBackButton = ({
  title,
  onClick,
  className,
  headerStyle,
}: HeaderBackButtonProps) => {
  const history = useHistory();

  return (
    <div className={styles.container}>
      <Button
        className={clsx(
          styles.button,
          styles.darwin && electronService.getPlatform() === "darwin",
          className,
        )}
        onClick={onClick || history.goBack}
        testID="back"
        variant="icon"
      >
        <BackIcon />
      </Button>
      {title && (
        <div style={headerStyle?.textStyle} className={styles.title}>
          {title}
        </div>
      )}
    </div>
  );
};
export default HeaderBackButton;
